module.exports = __webpack_public_path__ + "img/wiseEstimateWatermarkMobile.56cca339.png";